/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
import RESOURCE_NAMES from '../App/resources';
var CHANGE_OWNERSHIP_ACTION_TYPES = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.applicationFormOwnership); // eslint-disable-next-line import/prefer-default-export

export { CHANGE_OWNERSHIP_ACTION_TYPES };